module.exports = __webpack_public_path__ + "static/img/btn7.239587ee.png";